module.exports = __webpack_public_path__ + "static/img/zf_img_function01.fe4a886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_img_function01.png
// module id = BJso
// module chunks = 1